'use strict';

angular.module('imagetrend.components', [
    'imagetrend.components.tpl',
    'ngAnimate',
    'ui.bootstrap'
])
.run(['$rootScope', function ($rootScope) {
    $rootScope.formFieldScope = {
        // strings
        name: '@?',
        id: '@?',
        label: '@?',
        title: '@?',
        requiredText: '@?',
        classes: '@?',
        instructions: '@?',
        blankText: '@?',
        selectShow: '@?',
        selectSort: '@?',
        selectValue: '@?',
        availableShow: '@?',
        availableSort: '@?',
        compareValue: '@?',
        arrayValue: '@?',
        service: '@?',
        method: '@?',
        groupBy: '@?',
        size: '@?',
        maxLength: '@?',
        placeholder: '@?',

        // bools
        showBlank: '=?',
        showLabel: '=?',
        topLabel: '=?',
        showColon: '=?',
        modal: '=?',
        isRequired: '=?',
        showRequired: '=?',
        isDisabled: '=?',
        forceString: '=?',
        serviceOverride: '=?',
        multiple: '=?',
        sortable: '=?',
        vertical: '=?',
        pdf: '=?',
        innerForm: '=?'
    }
}])
.directive('focusOn', ['$timeout', function ($timeout) {
    return function (scope, element, attrs) {
        scope.$on(attrs.focusOn, function (e) {
            var timer = $timeout(function () {
                element[0].focus();
            }, 0);
            scope.$on('$destroy', function () {
                $timeout.cancel(timer);
            });
        });
    };
}])